import { mapGetters, mapActions } from "vuex";

import globalConfig from "../utiles/globalConfig";
import Fingerprint2 from "fingerprintjs2";

export const SAVE_LOGIN_TYPE_LOCALSTORAGE = "jp_h5_login_account";
export const UUID = "uuid"; //浏览器指纹
export const appId = "1864918903622253";
export const ACCOUNT_TYPE = {
  fb: "fb",
  tw: "tw",
  gp: "gp",
  gc: "gc",
  mg: "mg",
  to: "to",
};

export default {
  data() {
    return {
      saveTwResolve: null,
      action: "login",
      twiPopup: null,
    };
  },
  computed: {
    tips() {
      switch (this.action) {
        case "login":
          return "ログイン失敗";
        case "bind":
          return "バインド失敗";
        case "switch":
          return "アカウントを変更できませんでした";
        default:
          return "ログイン失敗";
      }
    },
  },
  methods: {
    readyFbLogin(type) {
      this.action = type;
      return this.checkFbLoginState().then((res) => {
        if (res.status === "connected") {
          return this.fbLogin({
            accessToken: res.authResponse.accessToken,
            appId: appId,
          });
        } else {
          return this.fbSdkLogin().then(this.readyFbLogin, (res) => {
            this.loginFail(res, ACCOUNT_TYPE.fb);
          });
        }
      });
    },

    checkFbLoginState() {
      return new Promise((resolve) => {
        FB.getLoginStatus((res) => {
          resolve(res);
        });
      });
    },

    fbSdkLogin() {
      return new Promise((resolve, reject) => {
        FB.login((res) => {
          if (res.status === "connected") {
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },

    readyBindFbAccount(type) {
      this.action = type;
      return this.checkFbLoginState().then((res) => {
        if (res.status === "connected") {
          return this.bindFbAccount({
            accessToken: res.authResponse.accessToken,
            appId: appId,
          });
        } else {
          return this.fbSdkLogin().then(this.readyBindFbAccount, (res) => {
            this.loginFail(res);
          });
        }
      });
    },

    startListenTwiLogin(win) {
      if (this.twiTimer) {
        clearInterval(this.twiTimer);
        this.twiTimer = null;
      }
      this.twiTimer = setInterval(() => {
        if (win.closed) {
          try {
            globalConfig.statistics("login_fail", {
              login_type: ACCOUNT_TYPE.tw,
              msg: "popup_close_by_user",
            });
          } catch (e) {}
          clearInterval(this.twiTimer);
          this.twiTimer = null;
          this.saveTwResolve({
            result: "0",
            msg: this.tips,
            data: {},
          });
        }
      }, 1000);
    },

    readyTwitterLogin(type) {
      this.action = type;
      return new Promise((resolve) => {
        let twiPopup = window.open(`https://jppassport.37games.com/web_twitter/init`);
        this.saveTwResolve = resolve;
        this.startListenTwiLogin(twiPopup);
      });
    },
    doTwitterLogin(res) {
      clearInterval(this.twiTimer);
      return this.twitterLogin({
        authToken: res.oauthToken,
        authSecret: res.oauthSecret,
      }).then((res) => {
        globalConfig.removeEventListener(this.readyDoTwiLogin);
        this.saveTwResolve && this.saveTwResolve instanceof Function ? this.saveTwResolve(res) : "";
      });
    },

    doTwitterBind(res) {
      clearInterval(this.twiTimer);
      return this.bindTwitterAccount({
        authToken: res.oauthToken,
        authSecret: res.oauthSecret,
      });
    },

    readyDoTwiLogin(e) {
      let res = e.data;
      if ("string" === typeof e.data) {
        res = JSON.parse(e.data);
      }
      this.doTwitterLogin(res);
    },

    readyTouristLogin() {
      this.action = "login";
      return this.getFingerprint()
        .then(this.touristLogin)
        .then((res) => {
          if (res.result != "1") {
            return this.loginFail(res, ACCOUNT_TYPE.to);
          } else {
            try {
              globalConfig.statistics("login_success", { login_type: ACCOUNT_TYPE.to });
            } catch (e) {}
            return new Promise((resolve) => {
              resolve(res);
            });
          }
        });
    },

    getFingerprint() {
      return new Promise((resolve) => {
        /**
         * 采用localstorage和cookie双储存
         */
        let locaUUid = globalConfig.getLclStorageItem(UUID);
        let cookUUid = globalConfig.getCookie(UUID);
        let saveUuid = locaUUid || cookUUid;
        if (saveUuid) {
          if (!cookUUid || (locaUUid && locaUUid !== cookUUid)) {
            globalConfig.setCookie(UUID, saveUuid);
          }
          if (!locaUUid) {
            globalConfig.setLclStorageItem(UUID, saveUuid);
          }
          resolve(saveUuid);
        } else {
          Fingerprint2.getV18(
            {
              excludes: {
                language: true,
              },
            },
            function(result, components) {
              let timestamp = new Date().valueOf();
              let realUuid = result + timestamp;
              globalConfig.setLclStorageItem(UUID, realUuid);
              globalConfig.setCookie(UUID, realUuid);
              resolve(realUuid);
            }
          );
        }
      });
    },

    getLoginId() {
      return globalConfig.getLclStorageItem(UUID) || globalConfig.getCookie(UUID) || "";
    },

    readySwitchMigrateCode(res, params) {
      return this.switchMigrateCode({
        code: params.extend,
        pw: params.pw,
        uuid: res,
      }).then((res) => {
        return new Promise((resolve) => {
          resolve(res);
        });
      });
    },

    loginFail(e, loginType) {
      if (this.action !== "bind") {
        try {
          globalConfig.statistics("login_fail", {
            login_type: loginType,
            msg: e.msg || e.error || e.status || e || "",
          });
        } catch (e) {}
      }
      return new Promise((resolve) => {
        resolve({
          result: "0",
          msg: this.tips,
          data: {},
        });
      });
    },

    readySwitchTwi(e) {
      let res = e.data;
      if ("string" === typeof e.data) {
        res = JSON.parse(e.data);
      }
      globalConfig.removeEventListener(this.readySwitchTwi);
      this.doTwitterLogin(res).then((res) => {
        this.saveTwResolve && this.saveTwResolve(res);
      });
    },
    readyBindTwi(e) {
      let res = e.data;
      if ("string" === typeof e.data) {
        res = JSON.parse(e.data);
      }
      globalConfig.removeEventListener(this.readyBindTwi);
      this.doTwitterBind(res).then((res) => {
        this.saveTwResolve && this.saveTwResolve(res);
      });
    },

    readyTwiLogin(type) {
      this.action = type;
      globalConfig.addEvenListener(this.readyDoTwiLogin);
      return this.readyTwitterLogin();
    },

    fbSdkPay(appId, order_id) {
      return new Promise((resolve, reject) => {
        FB.ui(
          {
            method: "pay",
            action: "purchaseitem",
            product: `https://jpstore.37games.com/facebook_local_money/product_items/app_id/${appId}/order_id/${order_id}`,
            request_id: order_id,
          },
          (res) => {
            if (res && !res["error_code"]) {
              resolve(res);
            } else {
              reject(res);
            }
          }
        );
      });
    },
    ...mapActions(["touristLogin", "fbLogin", "twitterLogin", "bindFbAccount", "bindTwitterAccount", "switchMigrateCode"]),
  },
};
